import {Navigate, useParams} from "react-router-dom";
import { Hardware } from "./hardware/Hardware";
import { Logistics } from "./logistics/Logistics";
import {Openings} from "./openings/Openings";
import { Pricing } from "./pricing/Pricing";
import {ManagerLockProvider} from "./ProjectActions";
import {Misc} from "./misc/Misc";
import {Div10} from "./div10/Div10";
import {Glazing} from "./glazing/Glazing";
import {FreeformChanges} from "./freeformchanges/FreeformChanges";
import {PriceLookupHotkeyPopup} from "../../priceLookup/PriceLookupHotkeyPopup";
import React from "react";
import {Keying2} from "./keying2/Keying2";

export function ShopDrawing() {
    return (
        <ManagerLockProvider>
            <Inner />
            <PriceLookupHotkeyPopup />
        </ManagerLockProvider>
    )
}

function Inner() {
    const params = useParams<{workspace: string, project: string}>();

    switch(params.workspace) {
        case "hardware":
            return <Hardware />
        case "logistics":
            return <Logistics />
        case "release":
            // the release screen now lives in logistics as a view
            return <Navigate to={`/project/${params.project}/shop-drawing/logistics?view=release`} replace />
        case "pricing":
            return <Pricing />
        case "changes":
            return <FreeformChanges />
        case "misc":
            return <Misc />
        case "keying":
            return <Keying2 />
        case "glazing":
            return <Glazing />
        case "div10":
            return <Div10 />
        default:
            return <Openings />
    }
}